export default __webpack_public_path__ + "media/images/mailer/wordmark-0bf3bd3d94b469b8603a198fdd65a1b5.png";